import React from 'react';

const QUICK = [
    { key: 'goal', icon: '⚽', label: 'Tor', cls: 'ticker-quick-btn--goal' },
    { key: 'yellow', icon: '🟨', label: 'Gelb', cls: 'ticker-quick-btn--yellow' },
    { key: 'red', icon: '🟥', label: 'Rot', cls: 'ticker-quick-btn--red' },
    { key: 'sub', icon: '🔄', label: 'Wechsel', cls: 'ticker-quick-btn--sub' },
    { key: 'chance', icon: '💥', label: 'Chance', cls: 'ticker-quick-btn--chance' },
];

export default function TickerQuickButtons({ onStartFlow, gameFinished, activeFlow }) {
    return (
        <div className={`ticker-quick-bar ${gameFinished ? 'ticker-quick-bar--disabled' : ''}`}>
            {QUICK.map((item) => (
                <button
                    key={item.key}
                    type="button"
                    className={`ticker-quick-btn ${item.cls} ${activeFlow === item.key ? 'ticker-quick-btn--active' : ''}`}
                    onClick={() => {
                        if (item.key === 'chance') onStartFlow('chance');
                        else onStartFlow(item.key);
                    }}
                    title={item.label}
                >
                    <span className="ticker-quick-btn-icon">{item.icon}</span>
                    <span>{item.label}</span>
                </button>
            ))}
        </div>
    );
}
